import { render, staticRenderFns } from "./receiptInfoDialog.vue?vue&type=template&id=5f2afcd7&scoped=true"
import script from "./receiptInfoDialog.vue?vue&type=script&lang=js"
export * from "./receiptInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./receiptInfoDialog.vue?vue&type=style&index=0&id=5f2afcd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2afcd7",
  null
  
)

export default component.exports